// This is generated.  Alter it in blockGroups/formElements/types/JsonViewer.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, required } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // Determine optional/editable flags based on the context (readOnly) and the required flag.
    let optional;
    let editable;
    if (!context?.readOnly) {
      editable = true;
      if (!required) {
        optional = true;
      }
    }

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) =>
      optional ? Type.Optional(schema) : schema;

    // Build the object schema (unknown shape)
    const objectOptions = {
      title: title,
      'x-id': id,
      'x-dataType': 'object',
      'x-propertyName': propertyName,
      'x-optional': !!optional,
      'x-editable': !!editable,
    };

    const jsonViewerSchema = maybeOptional(Type.Unknown(objectOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: jsonViewerSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'JsonViewer',
  module.exports,
);
